import React from 'react';
import PropTypes from 'prop-types';

const ShipmentTrackingIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString() : '148';
  const h = (height) ? height.toString() : '148';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 148 148"
      width={w}
      height={h}
    >
      <circle
        cx="74"
        cy="74"
        r="74"
        fill={(fill) || '#FF5F14'}
      />

      <path
                // eslint-disable-next-line max-len
        d="M58.293 29.6667C57.2498 29.6667 56.2561 30.1244 55.5618 30.9248L36.5921 52.7931C35.6426 53.3333 35 54.3718 35 55.5642V56.0619V112.571V113.167C35 114.916 36.3823 116.333 38.0875 116.333H109.912C111.618 116.333 113 114.916 113 113.167V71.8405V56.0619V55.5642C113 54.3718 112.357 53.3333 111.408 52.7931L92.4382 30.9248C91.7439 30.1244 90.7502 29.6667 89.707 29.6667H58.293ZM70.3408 52.3005H46.8246L59.9328 37.1894H70.3408V52.3005ZM77.6592 52.3005V37.1894H88.0672L101.175 52.3005H77.6592ZM42.3482 108.797V59.9342H105.652V108.797H42.3482Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="white"
      />

    </svg>
  );
};

ShipmentTrackingIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default ShipmentTrackingIcon;
